import "../../../styles/urunAgaci.css";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { uiState } from "../../state/uiState.js";

const API = "/api";

const LEVELS = [
	{
		key: "departman_urun_grubu_id",
		title: "Departman > Urun Grubu",
		parentKey: "departman_id",
		parentLabel: "Departman",
		listPath: (state) => `/urun-agaci/departman-gruplari?departman_id=${state.departman_id}`,
		createPath: "/urun-agaci/departman-gruplari",
		deletePath: (id) => `/urun-agaci/departman-gruplari/${id}`,
		primitivePath: "/urun-grubu-tanimlari",
		primitiveField: "urun_grubu_tanim_id",
		primitiveLabel: "Urun Grubu",
		chainSelectLabel: "Bagli Urun Gruplari",
	},
	{
		key: "urun_grubu_urun_alt_grubu_id",
		title: "Urun Grubu > Urun Alt Grubu",
		parentKey: "departman_urun_grubu_id",
		parentLabel: "Urun Grubu Iliskisi",
		listPath: (state) => `/urun-agaci/urun-alt-gruplari?departman_urun_grubu_id=${state.departman_urun_grubu_id}`,
		createPath: "/urun-agaci/urun-alt-gruplari",
		deletePath: (id) => `/urun-agaci/urun-alt-gruplari/${id}`,
		primitivePath: "/urun-alt-grubu-tanimlari",
		primitiveField: "urun_alt_grubu_tanim_id",
		primitiveLabel: "Urun Alt Grubu",
		chainSelectLabel: "Bagli Urun Alt Gruplari",
	},
	{
		key: "urun_alt_grubu_urun_cinsi_id",
		title: "Urun Alt Grubu > Urun Cinsi",
		parentKey: "urun_grubu_urun_alt_grubu_id",
		parentLabel: "Urun Alt Grubu Iliskisi",
		listPath: (state) => `/urun-agaci/urun-cinsleri?urun_grubu_urun_alt_grubu_id=${state.urun_grubu_urun_alt_grubu_id}`,
		createPath: "/urun-agaci/urun-cinsleri",
		deletePath: (id) => `/urun-agaci/urun-cinsleri/${id}`,
		primitivePath: "/urun-cinsi-tanimlari",
		primitiveField: "urun_cinsi_tanim_id",
		primitiveLabel: "Urun Cinsi",
		chainSelectLabel: "Bagli Urun Cinsleri",
	},
	{
		key: "urun_cinsi_marka_id",
		title: "Urun Cinsi > Marka",
		parentKey: "urun_alt_grubu_urun_cinsi_id",
		parentLabel: "Urun Cinsi Iliskisi",
		listPath: (state) => `/urun-agaci/markalar?urun_alt_grubu_urun_cinsi_id=${state.urun_alt_grubu_urun_cinsi_id}`,
		createPath: "/urun-agaci/markalar",
		deletePath: (id) => `/urun-agaci/markalar/${id}`,
		primitivePath: "/marka-tanimlari",
		primitiveField: "marka_tanim_id",
		primitiveLabel: "Marka",
		chainSelectLabel: "Bagli Markalar",
	},
	{
		key: "marka_model_id",
		title: "Marka > Model",
		parentKey: "urun_cinsi_marka_id",
		parentLabel: "Marka Iliskisi",
		listPath: (state) => `/urun-agaci/modeller?urun_cinsi_marka_id=${state.urun_cinsi_marka_id}`,
		createPath: "/urun-agaci/modeller",
		deletePath: (id) => `/urun-agaci/modeller/${id}`,
		primitivePath: "/model-tanimlari",
		primitiveField: "model_tanim_id",
		primitiveLabel: "Model",
		chainSelectLabel: "Bagli Modeller",
	},
];

const EMPTY_STATE = {
	departman_id: "",
	departman_urun_grubu_id: "",
	urun_grubu_urun_alt_grubu_id: "",
	urun_alt_grubu_urun_cinsi_id: "",
	urun_cinsi_marka_id: "",
};

let initialized = false;
let primitiveCache = null;

function showToast(message, type = "success") {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
			zIndex: "99999",
		},
	}).showToast();
}

function escapeHtml(value) {
	return String(value ?? "")
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")
		.replaceAll("'", "&#39;");
}

async function fetchJson(path, options = {}) {
	const res = await fetch(`${API}${path}`, options);
	const data = await res.json().catch(() => ({}));
	if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
	return data;
}

function ensureState() {
	if (!uiState["urun-agaci-yonetimi"]) {
		uiState["urun-agaci-yonetimi"] = { ...EMPTY_STATE };
	}
	return uiState["urun-agaci-yonetimi"];
}

async function ensurePrimitiveCache() {
	if (primitiveCache) return primitiveCache;

	const [
		departmanlar,
		urunGruplari,
		urunAltGruplari,
		urunCinsleri,
		markalar,
		modeller,
	] = await Promise.all([
		fetchJson("/departmanlar").then((d) => d.items || []),
		fetchJson("/urun-grubu-tanimlari").then((d) => d.items || []),
		fetchJson("/urun-alt-grubu-tanimlari").then((d) => d.items || []),
		fetchJson("/urun-cinsi-tanimlari").then((d) => d.items || []),
		fetchJson("/marka-tanimlari").then((d) => d.items || []),
		fetchJson("/model-tanimlari").then((d) => d.items || []),
	]);

	primitiveCache = {
		departmanlar,
		"/urun-grubu-tanimlari": urunGruplari,
		"/urun-alt-grubu-tanimlari": urunAltGruplari,
		"/urun-cinsi-tanimlari": urunCinsleri,
		"/marka-tanimlari": markalar,
		"/model-tanimlari": modeller,
	};
	return primitiveCache;
}

function buildOptions(items, placeholder, selectedValue = "") {
	const normalized = String(selectedValue ?? "");
	const placeholderHtml = `<option value=""${normalized ? "" : " selected"}>${escapeHtml(placeholder)}</option>`;
	const optionsHtml = (items || []).map((item) => {
		const value = String(item.id);
		const selected = value === normalized ? " selected" : "";
		const label = escapeHtml(item.name ?? "");
		return `<option value="${value}"${selected} title="${label}">${label}</option>`;
	}).join("");
	return `${placeholderHtml}${optionsHtml}`;
}

function getSelectedParentLabel(level, state, chainData) {
	if (level.parentKey === "departman_id") {
		const departman = primitiveCache?.departmanlar?.find((item) => String(item.id) === String(state.departman_id));
		return departman?.name || null;
	}

	const parentLevel = LEVELS.find((item) => item.key === level.parentKey);
	const parentItems = chainData[parentLevel?.key] || [];
	const selected = parentItems.find((item) => String(item.id) === String(state[level.parentKey]));
	return selected?.name || null;
}

function renderListTable(level, items) {
	if (!items?.length) {
		return `<div class="urun-agaci-empty">Bu seviyede tanimli iliski yok.</div>`;
	}

	return `
		<table class="urun-agaci-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>Ad</th>
					<th>Bagli Demirbas</th>
					<th>Alt Iliski</th>
					<th>Islem</th>
				</tr>
			</thead>
			<tbody>
				${items.map((item) => `
					<tr>
						<td>${item.id}</td>
						<td><span class="urun-agaci-cell" title="${escapeHtml(item.name)}">${escapeHtml(item.name)}</span></td>
						<td>${Number(item.demirbas_count ?? 0)}</td>
						<td>${Number(item.child_count ?? 0)}</td>
						<td class="urun-agaci-actions">
							<button
								type="button"
								class="urun-agaci-delete-btn"
								data-level="${level.key}"
								data-id="${item.id}"
								data-name="${escapeHtml(item.name)}"
							>
								Sil
							</button>
						</td>
					</tr>
				`).join("")}
			</tbody>
		</table>
	`;
}

function buildLevelSection(level, state, chainData) {
	const items = chainData[level.key] || [];
	const primitiveItems = primitiveCache?.[level.primitivePath] || [];
	const parentLabel = getSelectedParentLabel(level, state, chainData);
	const parentReady = Boolean(state[level.parentKey]);

	return `
		<section class="urun-agaci-section">
			<div class="urun-agaci-section-header">
				<div>
					<h3>${level.title}</h3>
					<p>${parentReady ? `${level.parentLabel}: ${escapeHtml(parentLabel || "")}` : `${level.parentLabel} se\u00e7meden bu seviye y\u00f6netilemez.`}</p>
				</div>
				<span class="urun-agaci-count">${items.length} kayit</span>
			</div>
			<div class="urun-agaci-add-row">
				<select class="urun-agaci-add-select" data-level="${level.key}" ${parentReady ? "" : "disabled"}>
					${buildOptions(primitiveItems, `${level.primitiveLabel} se\u00e7iniz`)}
				</select>
				<button type="button" class="urun-agaci-add-btn" data-level="${level.key}" ${parentReady ? "" : "disabled"}>
					Ekle
				</button>
			</div>
			${renderListTable(level, items)}
		</section>
	`;
}

function buildLayout(state, chainData) {
	return `
		<div class="urun-agaci-layout">
			<section class="urun-agaci-hero">
				<div>
					<h2>Urun Agaci Yonetimi</h2>
					<p>Tan\u0131mlar sayfas\u0131ndaki primitive kay\u0131tlar burada birbirine ba\u011flan\u0131r. Demirba\u015f create/edit yaln\u0131z bu tan\u0131ml\u0131 zincirlerden se\u00e7im yapar.</p>
				</div>
				<button type="button" class="urun-agaci-seed-btn">Canli Zinciri Tara</button>
			</section>

			<section class="urun-agaci-chain">
				<div class="urun-agaci-chain-grid">
					<div class="column-container">
						<label for="ua_departman">Departman</label>
						<select id="ua_departman" data-chain-key="departman_id">
							${buildOptions(primitiveCache?.departmanlar || [], "Departman se\u00e7iniz", state.departman_id)}
						</select>
					</div>
					<div class="column-container">
						<label for="ua_urun_grubu">Bagli Urun Gruplari</label>
						<select id="ua_urun_grubu" data-chain-key="departman_urun_grubu_id" ${state.departman_id ? "" : "disabled"}>
							${buildOptions(chainData.departman_urun_grubu_id || [], "Urun grubu iliskisi se\u00e7iniz", state.departman_urun_grubu_id)}
						</select>
					</div>
					<div class="column-container">
						<label for="ua_urun_alt_grubu">Bagli Urun Alt Gruplari</label>
						<select id="ua_urun_alt_grubu" data-chain-key="urun_grubu_urun_alt_grubu_id" ${state.departman_urun_grubu_id ? "" : "disabled"}>
							${buildOptions(chainData.urun_grubu_urun_alt_grubu_id || [], "Urun alt grubu iliskisi se\u00e7iniz", state.urun_grubu_urun_alt_grubu_id)}
						</select>
					</div>
					<div class="column-container">
						<label for="ua_urun_cinsi">Bagli Urun Cinsleri</label>
						<select id="ua_urun_cinsi" data-chain-key="urun_alt_grubu_urun_cinsi_id" ${state.urun_grubu_urun_alt_grubu_id ? "" : "disabled"}>
							${buildOptions(chainData.urun_alt_grubu_urun_cinsi_id || [], "Urun cinsi iliskisi se\u00e7iniz", state.urun_alt_grubu_urun_cinsi_id)}
						</select>
					</div>
					<div class="column-container">
						<label for="ua_marka">Bagli Markalar</label>
						<select id="ua_marka" data-chain-key="urun_cinsi_marka_id" ${state.urun_alt_grubu_urun_cinsi_id ? "" : "disabled"}>
							${buildOptions(chainData.urun_cinsi_marka_id || [], "Marka iliskisi se\u00e7iniz", state.urun_cinsi_marka_id)}
						</select>
					</div>
				</div>
			</section>

			<div class="urun-agaci-sections">
				${LEVELS.map((level) => buildLevelSection(level, state, chainData)).join("")}
			</div>
		</div>
	`;
}

async function loadChainData(state) {
	const chainData = {
		departman_urun_grubu_id: [],
		urun_grubu_urun_alt_grubu_id: [],
		urun_alt_grubu_urun_cinsi_id: [],
		urun_cinsi_marka_id: [],
		marka_model_id: [],
	};

	if (state.departman_id) {
		chainData.departman_urun_grubu_id = (await fetchJson(`/urun-agaci/departman-gruplari?departman_id=${state.departman_id}`)).items || [];
	}
	if (state.departman_urun_grubu_id) {
		chainData.urun_grubu_urun_alt_grubu_id = (await fetchJson(`/urun-agaci/urun-alt-gruplari?departman_urun_grubu_id=${state.departman_urun_grubu_id}`)).items || [];
	}
	if (state.urun_grubu_urun_alt_grubu_id) {
		chainData.urun_alt_grubu_urun_cinsi_id = (await fetchJson(`/urun-agaci/urun-cinsleri?urun_grubu_urun_alt_grubu_id=${state.urun_grubu_urun_alt_grubu_id}`)).items || [];
	}
	if (state.urun_alt_grubu_urun_cinsi_id) {
		chainData.urun_cinsi_marka_id = (await fetchJson(`/urun-agaci/markalar?urun_alt_grubu_urun_cinsi_id=${state.urun_alt_grubu_urun_cinsi_id}`)).items || [];
	}
	if (state.urun_cinsi_marka_id) {
		chainData.marka_model_id = (await fetchJson(`/urun-agaci/modeller?urun_cinsi_marka_id=${state.urun_cinsi_marka_id}`)).items || [];
	}

	return chainData;
}

async function rerender(view) {
	const state = ensureState();
	if (!primitiveCache) {
		view.innerHTML = `<div class="urun-agaci-loading">Yukleniyor...</div>`;
	}
	await ensurePrimitiveCache();
	const chainData = await loadChainData(state);
	view.innerHTML = buildLayout(state, chainData);
}

function resetDownstream(chainKey) {
	const state = ensureState();
	const index = ["departman_id", "departman_urun_grubu_id", "urun_grubu_urun_alt_grubu_id", "urun_alt_grubu_urun_cinsi_id", "urun_cinsi_marka_id"].indexOf(chainKey);
	if (index === -1) return;
	const keys = ["departman_id", "departman_urun_grubu_id", "urun_grubu_urun_alt_grubu_id", "urun_alt_grubu_urun_cinsi_id", "urun_cinsi_marka_id"];
	for (let i = index + 1; i < keys.length; i += 1) state[keys[i]] = "";
}

function clearStateForDeletedLevel(levelKey, deletedId) {
	const state = ensureState();
	const keys = ["departman_urun_grubu_id", "urun_grubu_urun_alt_grubu_id", "urun_alt_grubu_urun_cinsi_id", "urun_cinsi_marka_id"];
	const levelIndex = keys.indexOf(levelKey);
	if (levelIndex === -1) return;
	for (let i = levelIndex; i < keys.length; i += 1) {
		if (String(state[keys[i]]) === String(deletedId) || i > levelIndex) {
			state[keys[i]] = "";
		}
	}
}

function bindEvents(view) {
	if (view.dataset.bound === "true") return;
	view.dataset.bound = "true";

	view.addEventListener("change", async (event) => {
		const chainSelect = event.target.closest("[data-chain-key]");
		if (!chainSelect) return;
		const state = ensureState();
		state[chainSelect.dataset.chainKey] = chainSelect.value || "";
		resetDownstream(chainSelect.dataset.chainKey);
		await rerender(view);
	});

	view.addEventListener("click", async (event) => {
		const seedBtn = event.target.closest(".urun-agaci-seed-btn");
		if (seedBtn) {
			try {
				const result = await fetchJson("/urun-agaci/seed", { method: "POST" });
				const counts = result.counts || {};
				showToast(
					`Canli zincir tarandi. DG:${counts.departman_urun_grubu || 0} GAG:${counts.urun_grubu_urun_alt_grubu || 0} AUC:${counts.urun_alt_grubu_urun_cinsi || 0}`,
					"success",
				);
			} catch (err) {
				showToast(err.message || "Canli zincir taranamadi.", "error");
			}
			return;
		}

		const addBtn = event.target.closest(".urun-agaci-add-btn");
		if (addBtn) {
			const level = LEVELS.find((item) => item.key === addBtn.dataset.level);
			if (!level) return;
			const select = view.querySelector(`.urun-agaci-add-select[data-level="${level.key}"]`);
			const childValue = select?.value || "";
			if (!childValue) {
				showToast(`${level.primitiveLabel} secmelisiniz.`, "error");
				return;
			}
			const state = ensureState();
			const body = {
				[level.parentKey]: state[level.parentKey],
				[level.primitiveField]: childValue,
			};
			try {
				await fetchJson(level.createPath, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				});
				await rerender(view);
				showToast("Iliski eklendi.", "success");
			} catch (err) {
				showToast(err.message || "Iliski eklenemedi.", "error");
			}
			return;
		}

		const deleteBtn = event.target.closest(".urun-agaci-delete-btn");
		if (deleteBtn) {
			const level = LEVELS.find((item) => item.key === deleteBtn.dataset.level);
			if (!level) return;
			const label = deleteBtn.dataset.name || "kayit";
			const approved = window.confirm(`${label} iliskisini silmek istiyor musunuz?`);
			if (!approved) return;
			try {
				await fetchJson(level.deletePath(deleteBtn.dataset.id), { method: "DELETE" });
				clearStateForDeletedLevel(level.key, deleteBtn.dataset.id);
				await rerender(view);
				showToast("Iliski silindi.", "success");
			} catch (err) {
				showToast(err.message || "Iliski silinemedi.", "error");
			}
		}
	});
}

export async function renderUrunAgaciPage() {
	if (!document.getElementById("urun-agaci-yonetimi-view")) {
		document.getElementById("page-content").insertAdjacentHTML("beforeend", '<div id="urun-agaci-yonetimi-view"></div>');
	}

	const view = document.getElementById("urun-agaci-yonetimi-view");
	if (!view) return;

	if (!initialized) {
		initialized = true;
		ensureState();
	}

	bindEvents(view);
	try {
		primitiveCache = null;
		await rerender(view);
	} catch (err) {
		console.error("Urun agaci sayfasi render hatasi:", err);
		view.innerHTML = `<div class="urun-agaci-empty">Sayfa yuklenemedi.</div>`;
	}
}

export function resetUrunAgaciPage() {
	primitiveCache = null;
	uiState["urun-agaci-yonetimi"] = { ...EMPTY_STATE };
}
